import { c as _c } from "react/compiler-runtime";
import { BenefitTiles } from '@/components/tiles';
import { IconTile } from '@/components/IconTile';
import { useTranslation } from 'react-i18next';
import React from 'react';
import IconThumbUp from '@/assets/icons/heroIcons/Thumb-up.svg';
import IconCog from '@/assets/icons/heroIcons/Cog.svg';
import IconPay from '@/assets/icons/heroIcons/Pay.svg';
import IconHome from '@/assets/icons/heroIcons/Home.svg';
import { SectionHeadline } from '@/components/SectionHeadline';
export function ItPaysOff() {
  const $ = _c(33);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["extendedWarranty"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("itPaysOff.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mx-auto max-w-142" anchorKey="itPaysOff.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("itPaysOff.items.1");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <IconTile icon={<IconThumbUp className="[transform:rotateY(180deg)]" />} />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = {
      title: t3,
      icon: t4
    };
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("itPaysOff.items.2");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <IconTile icon={<IconPay />} />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6) {
    t8 = {
      title: t6,
      icon: t7
    };
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t) {
    t9 = t("itPaysOff.items.3");
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <IconTile icon={<IconCog />} />;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t9) {
    t11 = {
      title: t9,
      icon: t10
    };
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t) {
    t12 = t("itPaysOff.items.4");
    $[20] = t;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <IconTile icon={<IconHome />} />;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t12) {
    t14 = {
      title: t12,
      icon: t13
    };
    $[23] = t12;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t11 || $[26] !== t14 || $[27] !== t5 || $[28] !== t8) {
    t15 = <BenefitTiles background="bg-white" items={[t5, t8, t11, t14]} />;
    $[25] = t11;
    $[26] = t14;
    $[27] = t5;
    $[28] = t8;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t15 || $[31] !== t2) {
    t16 = <div className="flex flex-col gap-12 px-4 lg:gap-16">{t2}{t15}</div>;
    $[30] = t15;
    $[31] = t2;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  return t16;
}